import { Injectable } from '@angular/core';
import { Observable, first } from 'rxjs';
import { Modifier } from '@prlw/core/monitor/types/common';
import { defaultAllTableModifier } from '@prlw/core/monitor/init/common';
import { UserSettingsController } from '@prlw/core/user-settings/user-settings.controller';
import { Setting } from '../user-settings/setting.interface';

const ALL_TABLE_MODIFIER_SETTING = new Setting<Modifier>('all-table-modifier');

@Injectable({
  providedIn: 'root',
})
export class AllTableModifiersService {
  public readonly modifier$: Observable<Modifier>;

  constructor(private readonly userSettingsController: UserSettingsController) {
    this.modifier$ = userSettingsController.setting$(
      ALL_TABLE_MODIFIER_SETTING,
      defaultAllTableModifier,
    );
  }

  public updateModifier(modifier: Modifier) {
    this.userSettingsController
      .updateSetting(ALL_TABLE_MODIFIER_SETTING, modifier)
      .pipe(first())
      .subscribe();
  }
}
